import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { T, fonts } from '../styles/theme'

export default function Login() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleLogin() {
    if (!email || !password) { setError('Rellena email y contraseña'); return }
    setLoading(true)
    setError('')
    const { error } = await signIn(email, password)
    if (error) setError('Email o contraseña incorrectos')
    setLoading(false)
  }

  return (
    <>
      <style>{`
        ${fonts}
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: ${T.bg}; font-family: 'DM Sans', sans-serif; }
      `}</style>
      <div style={{
        minHeight: '100vh', background: T.bg, display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        padding: '32px 24px', fontFamily: 'DM Sans, sans-serif'
      }}>
        {/* Logo */}
        <div style={{
          width: 68, height: 68, borderRadius: 22,
          background: T.accentSoft, border: `1px solid ${T.accent}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 30, marginBottom: 24
        }}>🥗</div>

        <div style={{ fontSize: 28, fontWeight: 700, color: T.text, letterSpacing: -0.5, marginBottom: 6 }}>
          NutriControl
        </div>
        <div style={{ fontSize: 14, color: T.muted, marginBottom: 40, textAlign: 'center' }}>
          Control clínico de nutrición y composición corporal
        </div>

        {/* Formulario */}
        <div style={{ width: '100%', maxWidth: 360 }}>
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 13, color: T.sub, marginBottom: 6 }}>Email</div>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="tu@email.com"
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              style={{
                width: '100%', background: T.card, border: `1px solid ${T.cardB}`,
                borderRadius: 12, padding: '13px 16px', color: T.text,
                fontSize: 15, fontFamily: 'DM Sans, sans-serif', outline: 'none'
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: T.sub, marginBottom: 6 }}>Contraseña</div>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="········"
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              style={{
                width: '100%', background: T.card, border: `1px solid ${T.cardB}`,
                borderRadius: 12, padding: '13px 16px', color: T.text,
                fontSize: 15, fontFamily: 'DM Sans, sans-serif', outline: 'none'
              }}
            />
          </div>

          {error && (
            <div style={{
              background: 'rgba(248,113,113,0.12)', border: `1px solid ${T.danger}`,
              borderRadius: 10, padding: '10px 14px', fontSize: 13,
              color: T.danger, marginBottom: 16
            }}>
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              width: '100%', padding: 14, borderRadius: 14,
              background: loading ? T.muted : T.accent,
              color: '#000', fontSize: 15, fontWeight: 700,
              border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'DM Sans, sans-serif', transition: 'opacity .15s'
            }}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </div>

        <div style={{ fontSize: 11, color: T.muted, marginTop: 32, textAlign: 'center', lineHeight: 1.6 }}>
          Los accesos los gestiona el administrador.<br />
          Contacta con tu responsable si no tienes cuenta.
        </div>
      </div>
    </>
  )
}